import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Directive, ElementRef, forwardRef, HostListener, inject } from '@angular/core';
import { noop, removeWrappingCommas } from '@ps-gui/shared-utils';

@Directive({
  selector: 'input[ctExtractionRemoveWrappingCommaInput],div[ctExtractionRemoveWrappingCommaInput]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RemoveWrappingCommaValueAccessor),
      multi: true,
    },
  ],
})
export class RemoveWrappingCommaValueAccessor implements ControlValueAccessor {
  private onTouched: () => void = noop;

  private readonly element = inject(ElementRef);

  onChange: (value: unknown) => void = noop;

  writeValue(value: string): void {
    const newValue = value ? removeWrappingCommas(String(value)) : value;

    const elem: HTMLElement = this.element.nativeElement;

    if (elem.tagName === 'DIV') {
      elem.innerText = newValue;
    } else if (elem.tagName === 'INPUT') {
      (elem as HTMLInputElement).value = newValue;
    } else {
      console.error('Unsupported tag: ', elem.tagName);
    }
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  @HostListener('input')
  handleInput(): void {
    this.onChange(this.getValue());
  }

  @HostListener('blur')
  handleBlur(): void {
    this.writeValue(this.getValue());
    this.onTouched();
  }

  private getValue() {
    const elem: HTMLElement = this.element.nativeElement;

    if (elem.tagName === 'DIV') {
      // divs with the contenteditable attribute contain a linebreak when the user
      // clears the field, which needs to be removed to ensure that validation works
      // properly
      if (elem.innerText === '\n') {
        return '';
      }

      return elem.innerText;
    }

    if (elem.tagName === 'INPUT') {
      return (elem as HTMLInputElement).value;
    }

    console.error('Unsupported tag: ', elem.tagName);
    return '';
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
